import React from "react";
import { Link } from "react-router-dom";

const baseBtn = "inline-flex items-center justify-center gap-2 h-12 rounded-xl px-6 text-[length:var(--step-0)] font-medium transition-[transform,background-color,border-color,color,box-shadow] duration-200 ease-[var(--ease-out)] active:translate-y-[1px]";

export const PrimaryButton = ({ to, href, children, className = "", ...props }) => {
  const cls = `${baseBtn} bg-gold text-black hover:bg-gold-soft shadow-[var(--shadow-1)] hover:shadow-[0_18px_55px_rgba(0,0,0,0.5)] ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
};

export const SecondaryButton = ({ to, href, children, className = "", ...props }) => {
  const cls = `${baseBtn} border border-[color:var(--border-strong)] bg-transparent text-white hover:border-[color:var(--gold-hairline)] hover:bg-white/[0.03] ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
};

// Tertiary / communication button — quiet neutral, gold reserved for the icon
export const GhostButton = ({ to, href, children, className = "", ...props }) => {
  const cls = `${baseBtn} border border-[color:var(--border-neutral)] bg-white/[0.03] text-white/90 hover:bg-white/[0.06] hover:text-white ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
};

export const SectionHeading = ({ kicker, title, subtitle, center, className = "" }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
    {kicker && <p className="kicker mb-3">{kicker}</p>}
    <h2 className="display-2 text-white">{title}</h2>
    {subtitle && <p className={`mt-4 text-secondary u-body ${center ? "mx-auto" : ""} max-w-[var(--measure)]`}>{subtitle}</p>}
  </div>
);

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`section-y ${className}`}>
    <div className="container-ascendia">{children}</div>
  </section>
);

export const PageHero = ({ kicker, title, subtitle, image, children }) => (
  <section className="relative overflow-hidden border-b border-[color:var(--border-subtle)]">
    {image && (<><img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" /><div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/70 via-[#0B0B0C]/85 to-[#0B0B0C]" /></>)}
    <div className="hero-glow absolute inset-0" />
    <div className="container-ascendia relative py-20 sm:py-24 lg:py-28">
      {kicker && <p className="kicker mb-4">{kicker}</p>}
      <h1 className="display-2 text-white max-w-3xl">{title}</h1>
      {subtitle && <p className="mt-5 lede">{subtitle}</p>}
      {children && <div className="mt-8 flex flex-wrap gap-3">{children}</div>}
    </div>
  </section>
);
